import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */

class CheckIsActiveDealerService extends Service {
  constructor({repository}) {
    super()
    this._repository = repository
  }

  @inlineError
  execute(informationVO) {
    return this._repository
      .checkIsActiveDealer({
        informationVO
      })
      .then(([error, resultVO]) => {
        if (error) return Promise.reject(error)

        return resultVO
      })
  }
}

export {CheckIsActiveDealerService}
